module.exports = __webpack_public_path__ + "static/media/Monday_Step4_Image13.94b88812.webp";